// @ts-nocheck
import React, { FunctionComponent } from 'react';
import { FieldProps, getIn } from 'formik';

// MUI
import Box from '@mui/material/Box';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormHelperText from '@mui/material/FormHelperText';
import RadioGroup, { RadioGroupProps } from '@mui/material/RadioGroup';
import Radio from '@mui/material/Radio';

// Common
import { types } from '../../../../../types';

// Properties
import * as styles from './FormRadioGroup.styles';

type TFormRadioGroupProps = {
    options: types.TBaseDictionaryField;
    label?: string;
    disabledOptions?: number[];
    handleChange?: () => void;
}

const FormRadioGroup: FunctionComponent<FieldProps & RadioGroupProps & TFormRadioGroupProps> = props => {
    const isTouched = getIn(props.form.touched, props.field.name);
    const errorMessage = getIn(props.form.errors, props.field.name);

    const {
        options,
        onChange,
        handleChange,
        disabledOptions,
        required,
        label,
        disabled,
        error,
        helperText,
        field,
        form,
        ...rest
    } = props;

    const handleRadioChange = () => {
        if (handleChange) {
            handleChange();
        }
    }

    return (
        <FormControl
            disabled={disabled ?? form.isSubmitting}
            error={error ?? Boolean(isTouched && errorMessage)}
            required={required}
        >
            <Box sx={styles.radioWrapper}>
                {label && <FormLabel sx={styles.label}>{label}</FormLabel>}
                <RadioGroup
                    {...rest}
                    {...field}
                >
                    {
                        options.map(option => (
                            <FormControlLabel
                                key={option.id}
                                sx={styles.optionLabel}
                                control={
                                    <Radio
                                        onChange={handleRadioChange}
                                        size="small"
                                        disabled={disabled || (disabledOptions && !disabledOptions.includes(option.id))}
                                        sx={styles.radio}
                                    />
                                }
                                label={option.name}
                                value={option.id}
                            />
                        ))
                    }
                </RadioGroup>
            </Box>
            <FormHelperText sx={styles.helperText}>
                {helperText ?? ((isTouched && errorMessage) ? errorMessage : undefined)}
            </FormHelperText>
        </FormControl>
    );
};

export default FormRadioGroup;
